module.exports = __webpack_public_path__ + "img/wood.30ea97e8.svg";